export default "__VITE_ASSET__B1b5wdnf__"